/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'document': {
    width: 13,
    height: 15,
    viewBox: '0 0 13 15',
    data: '<path pid="0" clip-rule="evenodd" d="M8.44.956H3.726A2.706 2.706 0 001.01 3.597v7.589a2.712 2.712 0 002.65 2.77h5.725a2.753 2.753 0 002.64-2.77V4.693L8.44.956z" _stroke="#130F26" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M8.253.948v2.06c0 1.006.813 1.821 1.819 1.824h1.951M8.12 9.879H4.297M6.672 7.22H4.295" _stroke="#130F26" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/document.js